import { createSelector } from "reselect";
import _ from "lodash";
export const selectAllJobTemplates = ({ SSWPConfigCreator_reducer }) => {
    return SSWPConfigCreator_reducer.jobTemplates;
};
export const selectAllSSWPConfigs = ({ SSWPConfigCreator_reducer }) => {
    return SSWPConfigCreator_reducer.sswpMasterConfigs;
};
export const getRequesting = ({ SSWPConfigCreator_reducer }) => {
    return SSWPConfigCreator_reducer.requesting;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["master_sswp_v2"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectJobTemplates = createSelector(
    [selectAllJobTemplates],
    (allTemplates) => {
        if (!allTemplates) {
            return [];
        }
        let templateInfo = [];
        Object.keys(allTemplates).map((e) => {
            templateInfo.push({
                template_id: e,
                template_name: allTemplates[e].profile.template_title,
            });
            return null;
        });

        return templateInfo;
    }
);

export const selectSSWPConfigs = createSelector(
    [selectAllSSWPConfigs],
    (allConfigs) => {
        if (!allConfigs) {
            return [];
        }
        let conf = {};
        Object.keys(allConfigs).map((e) => {
            if (allConfigs[e].deleted !== true)
                conf = _.assign(conf, { [e]: allConfigs[e] });
            return null;
        });
        return conf;
    }
);
